import { ACCOUNT_TYPE } from '_constants';

import { Goal } from '../../types';
import usePermittedQuery from '../usePermittedQuery';

export const GET_PATIENT_GOALS = 'get-patient-goals';

export const useGetPatientGoals = (patientId: number) => {
  return usePermittedQuery<Goal[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/goal/all-goals/${patientId}`,
    {},
    [GET_PATIENT_GOALS, patientId],
    {
      enabled: typeof patientId === 'number' && patientId > 0,
      refetchOnWindowFocus: false,
    },
  );
};
